import { getUserSummaryInfo } from '@op/services';
import { useState } from 'react';

export function useUrlSummaryInfo() {
  const [loading, setLoading] = useState(true);
  const [isEmpty, setIsEmpty] = useState(false); 
  const [summaryInfo, setSummaryInfo] = useState<any>(null);

  function requestUrlInfo(params: any) {
    setSummaryInfo(null);
    setIsEmpty(false);
    setLoading(true);

    getUserSummaryInfo(params)
      .then((data: any) => {
        setSummaryInfo(data);
      })
      .catch(() => {
        setIsEmpty(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { loading, requestUrlInfo, summaryInfo, isEmpty };
}
